import "./App.css";
import Search from "./Search";
import bootstrap from "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Search defaultCity="Sydney" />
      </div>
      <footer>
        <a href="https://github.com/FlorSmile/weather-react">
          Open-source code
        </a>
        , by <a href="https://t.me/nlashtun">Nashtun Nadiia</a> from
        <a href="https://www.shecodes.io/">She Codes</a>
      </footer>
    </div>
  );
}

export default App;
